export default __webpack_public_path__ + "static/media/maintenance-2.2a63ae58.png";